import { Component, inject, OnInit, signal } from '@angular/core';
import { SidebarComponent } from '../../../core/sidebar/sidebar.component';
import { MapComponent } from '../../../core/map/map.component';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { HttpService } from '../../../service/http/http.service';
import { Route } from '../../../shared/models/ride-history/route.model';
import { DurationPipe } from '../../../shared/pipes/duration.pipe';
import { CorrectedDatePipe } from '@app/shared/pipes/corrected-date.pipe';
import { CommonModule, DatePipe } from '@angular/common';
import { DistanceConverterPipe } from '../../../shared/pipes/distance-converter.pipe';
import { environment } from '@environments/environment';
import { AltitudeAndSpeedGraphComponent } from '../../../shared/ngx-charts/altitude-and-speed-graph/altitude-and-speed-graph.component';
import { backendRestApis } from '@environments/backend-rest-apis';
import { Ride } from '@app/shared/models/ride-history/ride.model';
import { RideNameEditorComponent } from '../ride-name-editor/ride-name-editor.component';

@Component({
  selector: 'app-ride-details',
  imports: [
    SidebarComponent,
    DurationPipe,
    DatePipe,
    DistanceConverterPipe,
    CommonModule,
    AltitudeAndSpeedGraphComponent,
    MapComponent,
    RouterLink,
    CorrectedDatePipe,
    RideNameEditorComponent
  ],
  templateUrl: './ride-details.component.html',
  styleUrl: './ride-details.component.css',
})
/**
 * Komponenta za prikaz detalja pojedine vožnje.
 * Prikazuje rute i dodatne informacije za odabranu vožnju.
 */
export class RideDetailsComponent implements OnInit {
  rideId: number = 0;
  routes = signal<Route[] | undefined>(undefined);
  date: Date | undefined;
  ride = signal<Ride | undefined>(undefined);

  private route = inject(ActivatedRoute);
  private httpService = inject(HttpService);

  /**
   * Inicijalizira komponentu i dohvaća podatke o rutama za odabranu vožnju.
   */
  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.rideId = +params['rideId'];

      const url = `${environment.apiUrl}${backendRestApis.route.getAllRoutesWithRideId(this.rideId)}`;
      const subscription = this.httpService.get<Route[]>(url).subscribe({
        next: (routeArray) => {
          this.routes.set(routeArray);
          this.date = routeArray[0].startTime;
        },
      });

      this.httpService.unsubscribeWithDestroyRef(subscription);
    });

    this.loadRide();
  }

  loadRide() {
    const url = `${environment.apiUrl}${backendRestApis.ride.getById(this.rideId)}`;
    this.httpService.get<Ride>(url).subscribe({
      next: (ride) => this.ride.set(ride),
    });
  }
}
